import Partnership16 from '@carbon/icons-react/es/partnership/16';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';

export const TextWrapperWithEllipsis = styled.div`
  ${SingleLineEllipsis};
`;

export const PartnershipIcon = styled(Partnership16)`
  color: var(--gray-50);
  flex-shrink: 0;
`;
